import {
  Avatar,
  Box,
  Chip,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Skeleton,
  Typography,
} from "@mui/material";
import { DateTime } from "luxon";
import { DashCard } from "./DashCard";
import { colors, radius } from "../../data/tokens";
import { initials } from "../../util/text";
import { RecentMember } from "./useDashboardData";

const STATUS_CHIP: Record<
  string,
  { label: string; color: "success" | "warning" | "error" | "info" | "default" }
> = {
  ACTIVE: { label: "Ativo", color: "success" },
  PENDING: { label: "Pendente", color: "warning" },
  CANCELED: { label: "Cancelado", color: "default" },
  DECEASED: { label: "Falecido", color: "default" },
  LICENSED: { label: "Licenciado", color: "info" },
  NO_CONTACT: { label: "Sem contato", color: "warning" },
  UNKNOWN: { label: "Não informado", color: "default" },
};

// Últimos sócios cadastrados — clique abre o cadastro
export function RecentMembers({ recent }: { recent: RecentMember[] | null }) {
  return (
    <DashCard title="Últimos cadastros">
      {!recent ? (
        <Box>
          {Array.from({ length: 5 }, (_, i) => (
            <Skeleton key={i} variant="text" height={48} />
          ))}
        </Box>
      ) : recent.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          Nenhum cadastro recente.
        </Typography>
      ) : (
        <List disablePadding>
          {recent.map((member) => {
            const chip = STATUS_CHIP[member.accountStatus] ?? {
              label: member.accountStatus,
              color: "default" as const,
            };
            return (
              <ListItemButton
                key={member.id}
                sx={{ borderRadius: `${radius.sm}px`, px: 1 }}
                onClick={() => {
                  window.location.href = `/#/users/crud/${member.id}/show`;
                }}
              >
                <ListItemAvatar>
                  <Avatar
                    src={member.photoUrl}
                    sx={{
                      backgroundColor: colors.bgContent,
                      color: colors.primary,
                      fontWeight: 600,
                      fontSize: "0.9rem",
                    }}
                  >
                    {initials(member.fullName)}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={member.fullName}
                  secondary={
                    member.createdAt
                      ? DateTime.fromISO(member.createdAt)
                          .setLocale("pt-BR")
                          .toFormat("dd/MM/yyyy")
                      : "—"
                  }
                  primaryTypographyProps={{
                    noWrap: true,
                    fontSize: "0.9rem",
                  }}
                />
                <Chip size="small" color={chip.color} label={chip.label} />
              </ListItemButton>
            );
          })}
        </List>
      )}
    </DashCard>
  );
}
